<span><img src="@/assets/img/NewBlock_Warning.png" style="height:1em;vertical-align: middle;">{{'&nbsp;'}}<slot></slot></span>